import axios from 'axios';

interface ApiErrorData {
  body?: {
    message?: unknown;
  } | null;
  header?: {
    message?: unknown;
  } | null;
  message?: unknown;
}

const getNonEmptyString = (value: unknown): string | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }

  const message = value.trim();
  return message || undefined;
};

export const getApiErrorMessage = (error: unknown): string | undefined => {
  if (!axios.isAxiosError(error)) {
    return undefined;
  }

  const responseData = error.response?.data;
  if (!responseData || typeof responseData !== 'object') {
    return undefined;
  }

  const data = responseData as ApiErrorData;
  return (
    getNonEmptyString(data.body?.message) ??
    getNonEmptyString(data.header?.message) ??
    getNonEmptyString(data.message)
  );
};
